export var CONTENT_TYPES;
(function (CONTENT_TYPES) {
    CONTENT_TYPES["EVENT"] = "event";
    CONTENT_TYPES["FILE"] = "file";
    CONTENT_TYPES["FILEFOLDER"] = "filefolder";
    CONTENT_TYPES["FOLDER"] = "folder";
    CONTENT_TYPES["FORUM"] = "forum_discussion";
    CONTENT_TYPES["GROUP"] = "group";
    CONTENT_TYPES["NEWS"] = "news";
    CONTENT_TYPES["PEOPLE_DIRECTORY"] = "people_directory";
    CONTENT_TYPES["PROJECT"] = "project";
    CONTENT_TYPES["TRENDING"] = "trending";
})(CONTENT_TYPES || (CONTENT_TYPES = {}));
export var CONTENT_LIST_SIZES;
(function (CONTENT_LIST_SIZES) {
    CONTENT_LIST_SIZES["HIGHLIGHT"] = "highlight";
    CONTENT_LIST_SIZES["LARGE"] = "large";
    CONTENT_LIST_SIZES["SMALL"] = "small";
})(CONTENT_LIST_SIZES || (CONTENT_LIST_SIZES = {}));
//# sourceMappingURL=types.js.map